__turbopack_context__.v({
  "active": "Page-module__9NrG3W__active",
  "badItem": "Page-module__9NrG3W__badItem",
  "badgesRow": "Page-module__9NrG3W__badgesRow",
  "bentoCard": "Page-module__9NrG3W__bentoCard",
  "bentoGrid": "Page-module__9NrG3W__bentoGrid",
  "button": "Page-module__9NrG3W__button",
  "cardActive": "Page-module__9NrG3W__cardActive",
  "cardBad": "Page-module__9NrG3W__cardBad",
  "cardGood": "Page-module__9NrG3W__cardGood",
  "cardHeader": "Page-module__9NrG3W__cardHeader",
  "cardIconBg": "Page-module__9NrG3W__cardIconBg",
  "chip": "Page-module__9NrG3W__chip",
  "chipGrid": "Page-module__9NrG3W__chipGrid",
  "chipIcon": "Page-module__9NrG3W__chipIcon",
  "codePill": "Page-module__9NrG3W__codePill",
  "codeSection": "Page-module__9NrG3W__codeSection",
  "codeText": "Page-module__9NrG3W__codeText",
  "colSpan2": "Page-module__9NrG3W__colSpan2",
  "colSpan3": "Page-module__9NrG3W__colSpan3",
  "comparisonCard": "Page-module__9NrG3W__comparisonCard",
  "comparisonGrid": "Page-module__9NrG3W__comparisonGrid",
  "comparisonList": "Page-module__9NrG3W__comparisonList",
  "container": "Page-module__9NrG3W__container",
  "contentWrapper": "Page-module__9NrG3W__contentWrapper",
  "copyBtn": "Page-module__9NrG3W__copyBtn",
  "dashboardGrid": "Page-module__9NrG3W__dashboardGrid",
  "fadeIn": "Page-module__9NrG3W__fadeIn",
  "fadeUp": "Page-module__9NrG3W__fadeUp",
  "faqContent": "Page-module__9NrG3W__faqContent",
  "faqGrid": "Page-module__9NrG3W__faqGrid",
  "faqIcon": "Page-module__9NrG3W__faqIcon",
  "faqItem": "Page-module__9NrG3W__faqItem",
  "faqSummary": "Page-module__9NrG3W__faqSummary",
  "featureCard": "Page-module__9NrG3W__featureCard",
  "featureIconBox": "Page-module__9NrG3W__featureIconBox",
  "featureText": "Page-module__9NrG3W__featureText",
  "featuresGrid": "Page-module__9NrG3W__featuresGrid",
  "featuresSelector": "Page-module__9NrG3W__featuresSelector",
  "floatAnim1": "Page-module__9NrG3W__floatAnim1",
  "floatAnim2": "Page-module__9NrG3W__floatAnim2",
  "floatIcon": "Page-module__9NrG3W__floatIcon",
  "floatOrb": "Page-module__9NrG3W__floatOrb",
  "floatingIconsLayer": "Page-module__9NrG3W__floatingIconsLayer",
  "goodItem": "Page-module__9NrG3W__goodItem",
  "headerIcon": "Page-module__9NrG3W__headerIcon",
  "hero": "Page-module__9NrG3W__hero",
  "heroActions": "Page-module__9NrG3W__heroActions",
  "heroBadge": "Page-module__9NrG3W__heroBadge",
  "heroContent": "Page-module__9NrG3W__heroContent",
  "heroDescription": "Page-module__9NrG3W__heroDescription",
  "heroGlow1": "Page-module__9NrG3W__heroGlow1",
  "heroGlow2": "Page-module__9NrG3W__heroGlow2",
  "heroTitle": "Page-module__9NrG3W__heroTitle",
  "icon1": "Page-module__9NrG3W__icon1",
  "icon2": "Page-module__9NrG3W__icon2",
  "icon3": "Page-module__9NrG3W__icon3",
  "icon4": "Page-module__9NrG3W__icon4",
  "icon5": "Page-module__9NrG3W__icon5",
  "imageContainer": "Page-module__9NrG3W__imageContainer",
  "integrationItem": "Page-module__9NrG3W__integrationItem",
  "interactiveSection": "Page-module__9NrG3W__interactiveSection",
  "interactiveSplit": "Page-module__9NrG3W__interactiveSplit",
  "kommoCard": "Page-module__9NrG3W__kommoCard",
  "kommoHeader": "Page-module__9NrG3W__kommoHeader",
  "kommoIcon": "Page-module__9NrG3W__kommoIcon",
  "kommoWrapper": "Page-module__9NrG3W__kommoWrapper",
  "m3Card": "Page-module__9NrG3W__m3Card",
  "marqueeContainer": "Page-module__9NrG3W__marqueeContainer",
  "marqueeTrack": "Page-module__9NrG3W__marqueeTrack",
  "mockupContainer": "Page-module__9NrG3W__mockupContainer",
  "moduleBadge": "Page-module__9NrG3W__moduleBadge",
  "modulosSection": "Page-module__9NrG3W__modulosSection",
  "partnerSection": "Page-module__9NrG3W__partnerSection",
  "popularBadge": "Page-module__9NrG3W__popularBadge",
  "primary": "Page-module__9NrG3W__primary",
  "referralContainer": "Page-module__9NrG3W__referralContainer",
  "referralHeader": "Page-module__9NrG3W__referralHeader",
  "referralSection": "Page-module__9NrG3W__referralSection",
  "scrollMarquee": "Page-module__9NrG3W__scrollMarquee",
  "secondary": "Page-module__9NrG3W__secondary",
  "section": "Page-module__9NrG3W__section",
  "sectionTitle": "Page-module__9NrG3W__sectionTitle",
  "separator": "Page-module__9NrG3W__separator",
  "slideUpFade": "Page-module__9NrG3W__slideUpFade",
  "stepBadge": "Page-module__9NrG3W__stepBadge",
  "stepInfo": "Page-module__9NrG3W__stepInfo",
  "stepItem": "Page-module__9NrG3W__stepItem",
  "stepLine": "Page-module__9NrG3W__stepLine",
  "stepsContainer": "Page-module__9NrG3W__stepsContainer",
  "tabButton": "Page-module__9NrG3W__tabButton",
  "tabContent": "Page-module__9NrG3W__tabContent",
  "tabImage": "Page-module__9NrG3W__tabImage",
  "tabs": "Page-module__9NrG3W__tabs",
  "textContent": "Page-module__9NrG3W__textContent",
  "textGradient": "Page-module__9NrG3W__textGradient",
  "trustBadges": "Page-module__9NrG3W__trustBadges",
  "whatsappBtn": "Page-module__9NrG3W__whatsappBtn",
  "whitelabelPromo": "Page-module__9NrG3W__whitelabelPromo",
  "wlAction": "Page-module__9NrG3W__wlAction",
  "wlBadge": "Page-module__9NrG3W__wlBadge",
  "wlBenefitsList": "Page-module__9NrG3W__wlBenefitsList",
  "wlContent": "Page-module__9NrG3W__wlContent",
});
